<section id="main">
  <div class="container-fluid">
    <!-- START Title -->
    <div class="row">
      <div class="viber-ctn" style="position: relative;">
        <img class="img-ctn" src="img/hypo/addikochat.png"/>
      </div>
    </div>
    <div class="row p-t-15">
      <div class="col-xs-12">
        <div class="image-steps">

          <img src="img/hypo/viber/Koraci_aktivacije.png" alt=""/>

          <div class="text-in-picture text-in-picture-1">
            <div class="col-xs-3 col-sm-2 viber-bullet">1</div>
            <div class="col-xs-8 col-sm-10" translate="viber.step1"></div>
          </div>

          <div class="text-in-picture text-in-picture-2">
            <div class="col-xs-3 col-sm-2 viber-bullet">2</div>
            <div class="col-xs-9 col-sm-10" translate="viber.step2"></div>
          </div>

          <div class="text-in-picture text-in-picture-3">
            <div class="col-xs-3 col-sm-2 viber-bullet">3</div>
            <div class="col-xs-9 col-sm-10" translate="viber.step3"></div>
          </div>

          <div class="text-in-picture text-in-picture-4">
            <div class="col-xs-3 col-sm-2 viber-bullet">4</div>
            <div class="col-xs-9 col-sm-10" translate="viber.step4"></div>
          </div>

          <div class="col-xs-6 t-a-c">
            <button class="btn btn-default" translate="viber.becomeFollower" ng-click="viberActivateNew.becomeFollower();"></button>
          </div>

          <div class="col-xs-6 t-a-c">
            <button class="btn btn-default" translate="viber.activate" ng-click="viberActivateNew.activate();"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



